/* eslint-disable */
import Backbone from "backbone";
import _ from "underscore";
import SalesforceCouponModel from "src/account-rewards/SFCC/SalesforceCouponModel";
import CustomRewardModel from "src/account-rewards/custom-rewards/CustomRewardModel";
import RewardSupplierTangoModel from "src/account-rewards/gift-cards/RewardSupplierTangoModel";
import PaypalPayoutModel from "src/account-rewards/paypal-payouts/PaypalPayoutModel";
import CouponModel from "src/account-rewards/coupons/CouponModel";
import RewardSupplierModel from "src/account-rewards/RewardSupplierModel";
import pagination from "src/shared/pagination";

const RewardSupplierCollection = Backbone.Collection.extend(
    _.extend(
        {
            url: "/api/v6/reward-suppliers/built",

            model: function (attributes, options) {
                switch (attributes.reward_supplier_type) {
                    case RewardSupplierModel.REWARD_SUPPLIER_TYPES
                        .SALESFORCE_COUPON:
                        return new SalesforceCouponModel(attributes, options);

                    case RewardSupplierModel.REWARD_SUPPLIER_TYPES
                        .PAYPAL_PAYOUTS:
                        return new PaypalPayoutModel(attributes, options);

                    case RewardSupplierModel.REWARD_SUPPLIER_TYPES
                        .CUSTOM_REWARD:
                        return new CustomRewardModel(attributes, options);

                    case RewardSupplierModel.REWARD_SUPPLIER_TYPES
                        .MANUAL_COUPON:
                        return new CouponModel(attributes, options);

                    case RewardSupplierModel.REWARD_SUPPLIER_TYPES.TANGO_V2:
                        return new RewardSupplierTangoModel(
                            attributes,
                            options
                        );

                    default:
                        return new RewardSupplierModel(attributes, options);
                }
            },
            parse(response) {
                // This endpoint does not support pagination, this is replicating the standard behavior.
                const offset = this.getOffset();
                const limit = this.getLimit();
                const endIndex = offset + limit;
                const sorted = _.sortBy(
                    response,
                    model => -new Date(model.updated_date).getTime()
                );
                return sorted.slice(offset, endIndex);
            },
        },
        pagination
    )
);
export default RewardSupplierCollection;
